module.exports = "/_next/static/images/ReCap-4ccd25192b329c21fa21e6352c0f5087.jpg";